import React, { useState } from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import { Modal } from "@mui/material";
import ExamInfo from "./modals/ExamInfo";
import {
  SectionCard,
  EmptyState,
} from "../../../shares/dashboard/DashboardWidgets";

const ExamScore = () => {
  const [exams, setExams] = useState();
  const [examData, setExamData] = useState();
  const [examInfo, setExamInfo] = useState(false);
  const { Id } = useParams();

  const handleClose = () => {
    setExamInfo(false);
  };
  const handleOpen = (exam) => {
    setExamInfo(true);
    setExamData(exam);
  };

  const getExams = useFetch({
    method: "GET",
    url: `management/exam-scores/${Id}/user_scores_list/`,
    noHeader: false,
    trigger: true,
    setter: setExams,
  });

  return (
    <SectionCard title="نمرات آزمون‌ها" icon={FactCheckOutlinedIcon}>
      {exams?.length > 0 ? (
        <div className="flex flex-wrap gap-sm">
          {exams.map((exam) => (
            <button
              key={exam.id ?? exam.exam?.ExamName}
              type="button"
              onClick={() => handleOpen(exam)}
              className="inline-flex items-center rounded-pill border border-rule-subtle bg-surface-sunken px-md py-2xs text-sm text-ink transition-colors duration-150 hover:border-primary hover:bg-primary-soft hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
            >
              {exam.exam.ExamName}
            </button>
          ))}
        </div>
      ) : (
        <EmptyState
          icon={FactCheckOutlinedIcon}
          title="آزمونی ثبت نشده"
          description="برای این دانش‌آموز هنوز نمره آزمونی موجود نیست."
        />
      )}
      <Modal
        open={examInfo}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ExamInfo close={handleClose} data={examData} />
      </Modal>
    </SectionCard>
  );
};

export default ExamScore;
